import { useContent } from '../redux/reducer/content';
import { useUser } from '../redux/reducer/user';
import { useMemo } from 'react';
import { useElf } from '../redux/reducer/elf';
import { isMac } from '../utils/detector/detector';

export const useBathBackgroundData = () => {
  const { shopItems } = useContent() ?? {};
  const { profile } = useUser() ?? {};
  const items = profile?.items ?? [];
  const { activeRoom } = useElf();

  return useMemo(() => {
    if (!items || !shopItems) return [];

    const availableSlots = Object.values(shopItems.shower ?? {}).reduce(
      (acc, { system_name, eventRoomId }) => (eventRoomId === activeRoom ? [...acc, system_name] : acc),
      [],
    );

    return items
      ?.filter(({ is_equipped, slot, image }) => is_equipped && availableSlots.includes(slot) && image)
      ?.map(({ image, compressedImage }) => (isMac() ? compressedImage ?? image : image));
  }, [items, shopItems, activeRoom]);
};
